// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"tp-z","slideIn":"up-z"};